// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__KZ5sW","badge":"tabs_badge__caWVU","badge-yellow":"tabs_badge-yellow__wgkBL","badge-green":"tabs_badge-green__TQK0M","badge-red":"tabs_badge-red__QROmH"};